import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})

export class AdspDealService extends BaseEntityService {

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_ADSP_URL}/deal/`;
  public exchange_url = `${this.BASE_ADSP_URL}/exchanges/`;

  getDealSources(params={}) {
    params['start_element'] = 0;
    params['num_elements'] = 500;
    let url = this.buildUrl(`${this.exchange_url}`, '', params);
    return this.get(url);
  }

  dealBulkUpdate(data) {
    let url = `${this.resource_url}bulk-update/`;
    return this.post(url, data)
  }

}
